<template>
  <div>
    <v-form v-model="valid" ref="form">

      <EmailField v-model="email">
      </EmailField>
      <v-text-field v-model="password" ref="passwordfield" :label="$t('text.password')" dense min="8"
        :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (e1 = !e1)" :type="e1 ? 'password' : 'text'"
        id="pw" :rules="passwordRules" counter outlined required @keydown.enter="submit">
      </v-text-field>

      <WideBtn :text="$t('customer.portal.loginbutton')" color="var(--v-tertiary-base)" :disabled="!valid"
        :loading="loginInProgress" @click="submit()">
      </WideBtn>
      <WideBtn :text="$t('customer.portal.forgot_password')" color="var(--v-tertiary-base)" :disabled="loginInProgress"
        :filled="false" @click="mode = 'send'">
      </WideBtn>

      <v-snackbar v-model="snackbar" color="error">{{ snackbarText }}</v-snackbar>
    </v-form>
  </div>
</template>


<script>
import EmailField from '@/components/Inputs/EmailField.vue';
import WideBtn from '@/components/WideBtn.vue';

export default {
  name: "LoginContent",
  props: {
    loginFunction: {
      type: Function,
      required: true,
    }
  },
  components: {
    WideBtn,
    EmailField,
  },

  data() {
    return {
      snackbar: false,
      snackbarText: "",
      loginInProgress: false,
      valid: false,
      e1: true,
      password: "",
      passwordRules: [(v) => !!v || "Password is required"],
    };
  },

  mounted() { },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loginInProgress = true;
        this.loginFunction({ username: this.email, password: this.password })
          .then((result) => {
            if (!result.success) {
              this.snackbarText = result.errorMessage;
              this.snackbar = true;
            }
            this.loginInProgress = false;
          });
      }
    },
  },

  computed: {
    email: {
      get() {
        return this.getQueryParam("email", "");
      },
      set(update) {
        this.setQueryParam("email", update);
      },
    },

    mode: {
      get() {
        return this.getQueryParam("mode", "");
      },
      set(update) {
        this.setQueryParam("mode", update);
      },
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>